import { FC, memo } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { Icons } from '@studenten/ui-components';

import { APP_ROUTES } from 'constants/routes';
import { ContentWrapper } from 'src/common';

import { Container, AvatarWrapper, Text, Title, TextWrapper, LinkWrapper } from './Heading.styles';

export type HeadingProps = {
  profilePicSrc?: string;
  firstName?: string;
  lastName?: string;
};

const Heading: FC<HeadingProps> = ({ profilePicSrc, firstName = '', lastName = '' }) => {
  const userName = [firstName, lastName].filter(Boolean).join(' ');

  return (
    <ContentWrapper>
      <LinkWrapper>
        <Link passHref href={APP_ROUTES.PROFILE} prefetch={false}>
          <a>
            <Icons.BackIcon />
            <Text>Terug naar Mijn Profiel</Text>
          </a>
        </Link>
      </LinkWrapper>

      <Container>
        <AvatarWrapper>
          {profilePicSrc ? (
            <Image
              unoptimized
              priority
              width={80}
              height={80}
              src={profilePicSrc}
              alt="profile image"
            />
          ) : null}
        </AvatarWrapper>
        <TextWrapper>
          <Title>{userName} / Profiel Bewerken</Title>
          <Text>Maak je profiel compleet</Text>
        </TextWrapper>
      </Container>
    </ContentWrapper>
  );
};

export default memo(Heading);
